(function () {
  class SHRoomVisualizer {
    constructor() {
      this.modal = document.querySelector("[data-sh-room-visualizer-modal]");
      this.openButtons = document.querySelectorAll("[data-sh-open-room-visualizer]");
      this.closeButtons = document.querySelectorAll("[data-sh-close-room-visualizer]");

      if (!this.modal || !this.openButtons.length) return;

      this.baseImage = this.modal.querySelector("[data-sh-room-base-image]");
      this.floorArea = this.modal.querySelector("[data-sh-floor-area]");
      this.floorTexture = this.modal.querySelector("[data-sh-floor-texture]");
      this.productTitle = this.modal.querySelector("[data-sh-visualizer-product-title]");
      this.roomUpload = this.modal.querySelector("[data-sh-upload-room]");
      this.roomPresets = this.modal.querySelectorAll(".sh-room-preset");
      this.emptyState = this.modal.querySelector("[data-sh-empty-state]");

      this.opacityInput = this.modal.querySelector("[data-sh-opacity]");
      this.scaleInput = this.modal.querySelector("[data-sh-scale]");
      this.rotationInput = this.modal.querySelector("[data-sh-rotation]");
      this.skewInput = this.modal.querySelector("[data-sh-skew]");
      this.resetButton = this.modal.querySelector("[data-sh-reset-visualizer]");

      this.currentTexture = "";
      this.defaultSettings = {
        opacity: 82,
        scale: 190,
        rotation: 0,
        skew: -12
      };

      this.bindEvents();
      this.applySettings();
    }

    bindEvents() {
      this.openButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const title = button.getAttribute("data-product-title") || "";
          const texture = button.getAttribute("data-product-texture") || "";

          this.currentTexture = texture;

          if (this.productTitle) {
            this.productTitle.textContent = title;
          }

          if (this.floorTexture && texture) {
            this.floorTexture.style.backgroundImage = `url("${texture}")`;
          }

          this.openModal();
        });
      });

      this.closeButtons.forEach((button) => {
        button.addEventListener("click", () => this.closeModal());
      });

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && this.modal.classList.contains("is-open")) {
          this.closeModal();
        }
      });

      this.roomPresets.forEach((button) => {
        button.addEventListener("click", () => {
          const image = button.getAttribute("data-room-image");
          if (!image || !this.baseImage) return;

          this.roomPresets.forEach((preset) => preset.classList.remove("active"));
          button.classList.add("active");

          this.baseImage.src = image;
          this.hideEmptyState();
        });
      });

      if (this.roomUpload) {
        this.roomUpload.addEventListener("change", (event) => {
          const file = event.target.files && event.target.files[0];

          if (!file) return;

          if (!file.type.match("image.*")) {
            alert("Please upload a valid image file.");
            return;
          }

          const reader = new FileReader();

          reader.onload = (e) => {
            if (this.baseImage) {
              this.baseImage.src = e.target.result;
            }

            this.roomPresets.forEach((preset) => preset.classList.remove("active"));
            this.hideEmptyState();
          };

          reader.readAsDataURL(file);
        });
      }

      [this.opacityInput, this.scaleInput, this.rotationInput, this.skewInput].forEach((input) => {
        if (!input) return;

        input.addEventListener("input", () => {
          this.applySettings();
        });
      });

      if (this.resetButton) {
        this.resetButton.addEventListener("click", () => {
          this.resetSettings();
        });
      }
    }

    openModal() {
      this.modal.classList.add("is-open");
      this.modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("sh-room-visualizer-lock");

      this.applySettings();
    }

    closeModal() {
      this.modal.classList.remove("is-open");
      this.modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("sh-room-visualizer-lock");
    }

    applySettings() {
      if (!this.floorArea || !this.floorTexture) return;

      const opacity = this.opacityInput ? Number(this.opacityInput.value) : this.defaultSettings.opacity;
      const scale = this.scaleInput ? Number(this.scaleInput.value) : this.defaultSettings.scale;
      const rotation = this.rotationInput ? Number(this.rotationInput.value) : this.defaultSettings.rotation;
      const skew = this.skewInput ? Number(this.skewInput.value) : this.defaultSettings.skew;

      this.floorArea.style.opacity = opacity / 100;
      this.floorArea.style.transform = `perspective(820px) rotateX(60deg) skewX(${skew}deg)`;
      this.floorTexture.style.backgroundSize = `${scale}px auto`;
      this.floorTexture.style.transform = `rotate(${rotation}deg)`;
    }

    resetSettings() {
      if (this.opacityInput) this.opacityInput.value = this.defaultSettings.opacity;
      if (this.scaleInput) this.scaleInput.value = this.defaultSettings.scale;
      if (this.rotationInput) this.rotationInput.value = this.defaultSettings.rotation;
      if (this.skewInput) this.skewInput.value = this.defaultSettings.skew;

      this.applySettings();
    }

    hideEmptyState() {
      if (this.emptyState) {
        this.emptyState.style.display = "none";
      }
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    new SHRoomVisualizer();
  });

  document.addEventListener("shopify:section:load", function () {
    new SHRoomVisualizer();
  });
})();